const translations = {
  "en": {
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Delete means delete, this asset won't come back.": "Delete means delete, this asset won't come back.",
    "Delete Transaction?": "Delete Transaction?"
  },
  "zh-tw": {
    "Cancel": "取消",
    "Confirm": "確認",
    "Delete means delete, this asset won't come back.": "刪除後就是刪除，此資產交易紀錄無法復原。",
    "Delete Transaction?": "刪除交易紀錄？"
  }
};

export default translations;
